export default __webpack_public_path__ + "static/media/filterIC.1ce297be.svg";